import {IActionFn, IPageData} from '@/store/types';
import {IModuleState} from './types';
import {$http} from '@/axios';
import store from '@/store';

// 查询专案组列表
export const queryDpgPage: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDpgPage', {...state.dpgPage, loading: true});
        const res: IPageData = await $http.post('/v1/design/dpg/pagelist', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setDpgPage', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setDpgPage', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询无效的专案组列表
export const queryInvalidDpgPages: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setInvalidDpgPages', {...state.invalidDpgPage, loading: true});
        const params = {...payload, status: [0]};
        const res: IPageData = await $http.post('/v1/design/dpg/pagelist', params);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setInvalidDpgPages', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setInvalidDpgPages', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询已删除的专案列表
export const queryRestoreDpgPages: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setRestoreDpgPages', {...state.confirm, loading: true});
        const res: IPageData = await $http.post('/v1/design/dpg/restorepagelist', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setRestoreDpgPages', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setRestoreDpgPages', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询专案组详情
export const queryDpgDetail: IActionFn<IModuleState> = async ({commit}, dpgId) => {
    try {
        commit('setDpgDetail', {data: null, loading: true});
        const res = await $http.get(`/v1/design/dpg/${dpgId}/detail`);
        commit('setDpgDetail', {data: res});
    } catch (e) {
        commit('setDpgDetail', {data: null});
    }
};

// 查询专案组操作日志
export const queryDpgLogs: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDpgLogs', {...state.dpgLogs, loading: true});
        const res: IPageData = await $http.post('/v1/design/dpg/searchlogfortransfer', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setDpgLogs', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setDpgLogs', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询指定专案组的子专案列表(用于另存为杂志，使用详情接口)
export const queryDpjList: IActionFn<IModuleState> = async ({commit, state}, dpgId) => {
    try {
        commit('setDpjList', {...state.dpjList, loading: true});
        const res: any = await $http.get(`/v1/design/dpg/${dpgId}/detail`);
        const list = res?.childrenProject || [];
        commit('setDpjList', {data: list});
    } catch (e) {
        commit('setDpjList', {data: []});
    }
};

// 查询拥有专案的组织列表(用于列表搜索)
export const queryDpgOrgs: IActionFn<IModuleState> = async ({commit, state}) => {
    try {
        commit('setDpgOrgs', {...state.dpgOrgs, loading: true});
        const res = await $http.post('/v1/data/design/organization/list', {search: ''});
        commit('setDpgOrgs', {data: res});
    } catch (e) {
        commit('setDpgOrgs', {data: []});
    }
};

// 查询渠道组织列表(用于交付)
export const queryChannelOrgs: IActionFn<IModuleState> = async ({commit}, payload) => {
    try {
        commit('setChannelOrgs', {data: [], loading: true});
        const res = await $http.post('/v1/data/system/org/channelorgs', payload);
        commit('setChannelOrgs', {data: res});
    } catch (e) {
        commit('setChannelOrgs', {data: []});
    }
};

// 查询本组织归属的品牌列表(用于发布)
export const queryOwnBrands: IActionFn<IModuleState> = async ({commit}, isPlatformUser) => {
    try {
        commit('setOwnBrands', {data: [], loading: true});
        const res = isPlatformUser
            ? await $http.get('/v1/data/baseinfo/brand/ownerlistbyorg')
            : await $http.post('/v1/data/baseinfo/brand/ownerlist');
        commit('setOwnBrands', {data: res});
    } catch (e) {
        commit('setOwnBrands', {data: []});
    }
};

// 查询专案状态字典
export const queryStatusTypes: IActionFn<IModuleState> = async ({commit, state}) => {
    try {
        commit('setStatusTypes', {...state.statusTypes, loading: true});
        const res = await $http.get('/common/chooseoptions/DesignProjectStatus');
        commit('setStatusTypes', {data: res});
    } catch (e) {
        commit('setStatusTypes', {data: []});
    }
};

// 编辑专案组
export const editDpg: IActionFn<IModuleState> = async ({commit}, payload) => {
    try {
        commit('setLoading', true);
        await $http.post('/v1/design/dpg/modify', payload);
        store.commit('common/setToast', {visible: true, text: '保存成功'});
    } finally {
        commit('setLoading', false);
    }
};

// 发布专案组
export const publishDpg: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        const res: any = await $http.post('/v1/design/dpg/shelf', payload, {ignoreCode: [1626]});
        if (res?.rtnCode === 1626) {
            // 如果出现了 1626 业务错误，说明发布的专案组里存在未发布的物料，此时打开强制发布弹窗
            const resData = res?.data || [];
            const errData = JSON.parse(resData[0] || '[]')[0] || null;
            const dialogData = {errData, brandId: payload.brandId};
            commit('setDialog', {visible: true, type: 'dpg-release', data: dialogData});
            return false;
        } else {
            store.commit('common/setToast', {visible: true, text: '发布成功'});
            return true;
        }
    } catch (e) {
        return false;
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 强制发布专案组(二次确认后，才能强制发布)
export const releaseDpg: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDialog', {...state.dialog, loading: true});
        await $http.post('/v1/design/dpg/shelf', payload);
        store.commit('common/setToast', {visible: true, text: '发布成功'});
    } finally {
        commit('setDialog', {visible: false});
    }
};

// 下架专案组
export const shelfDpg: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/v1/design/dpg/shelf', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 删除专案组
export const deleteDpg: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/v1/design/dpg/delete', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 交付专案组(将平台专案组复制到指定组织下)
export const deliverDpg: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/v1/design/dpg/transfer', payload);
        store.commit('common/setToast', {visible: true, text: '交付成功'});
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 收集专案组(将非平台专案组复制到平台下)
export const collectDpg: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/v1/design/dpg/transfer', payload);
        store.commit('common/setToast', {visible: true, text: '收集成功'});
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 批量还原已删除的专案组
export const restoreDpg: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/v1/design/dpg/restore', payload);
        store.commit('common/setToast', {visible: true, text: '恢复成功'});
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 查询待添加的物品列表(左库)
export const queryAllModels: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setAllModels', {...state.allModels, loading: true});
        const res: IPageData = await $http.post('/v1/data/asset/item/search', payload);
        const {list: data, total, pageNum, pageSize} = res;
        commit('setAllModels', {data, total, pageNum, pageSize});
    } catch (e) {
        commit('setAllModels', {data: [], total: 0, pageNum: 0, pageSize: 0});
    }
};

// 查询待添加的材料列表(左库)
export const queryAllMaterials: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setAllMaterials', {...state.allMaterials, loading: true});
        const res: IPageData = await $http.post('/v1/data/asset/material/search', payload);
        const {list: data, total, pageNum, pageSize} = res;
        commit('setAllMaterials', {data, total, pageNum, pageSize});
    } catch (e) {
        commit('setAllMaterials', {data: [], total: 0, pageNum: 0, pageSize: 0});
    }
};

// 查询专案组的物料库(右库)
export const queryDpgLibs: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLibModels', {...state.libModels, loading: true});
        commit('setLibMaterials', {...state.libMaterails, loading: true});
        const res: any = await $http.post('/v1/design/dpg/listforlib', payload);
        commit('setLibModels', {data: res?.designProjectModelItemDtos || []});
        commit('setLibMaterials', {data: res?.designProjectMaterialInstanceItemDtos || []});
    } catch (e) {
        commit('setLibModels', {data: []});
        commit('setLibMaterials', {data: []});
    }
};

// 查询子专案的定制家具列表(右库)
export const queryDpgFurs: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLibFurnitures', {...state.libFurnitures, loading: true});
        const res = await $http.post('/v1/data/design/furnitureitemlist', payload);
        commit('setLibFurnitures', {data: res});
    } catch (e) {
        commit('setLibFurnitures', {data: []});
    }
};

// 查询物料库调整日志(右库)
export const queryLibLogs: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLibLogs', {...state.libLogs, loading: true});
        const res: IPageData = await $http.post('/v1/design/dpg/logforitem', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setLibLogs', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setLibLogs', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 添加物品到物料库(右库)
export const addDpgModel: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDialog', {...state.dialog, loading: true});
        await $http.post('/v1/client/design/dpg/additems', payload);
        store.commit('common/setToast', {visible: true, text: '新增成功'});
    } finally {
        commit('setDialog', {visible: false});
    }
};

// 添加材料到物料库(右库)
export const addDpgMaterial: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDialog', {...state.dialog, loading: true});
        await $http.post('/v1/client/design/dpg/addmaterials', payload);
        store.commit('common/setToast', {visible: true, text: '新增成功'});
    } finally {
        commit('setDialog', {visible: false});
    }
};

// 删除专案物品(右库)
export const deleteDpgModel: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/v1/client/design/dgp/removeitems', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 删除专案材料(右库)
export const deleteDpgMaterial: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/v1/client/design/dpg/removematerials', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 将一个专案的物料或拼装家具复制到另一个专案里(可以同时复制物料和拼装家具，或仅复制物料)
export const copyLibItems: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDialog', {...state.dialog, loading: true});
        await $http.post('/v1/client/design/group/copyitems', payload);
    } finally {
        commit('setDialog', {visible: false});
    }
};

// 将一个专案的拼装家具复制到另一个专案里(仅能复制拼装家具)
export const copyLibFurniture: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDialog', {...state.dialog, loading: true});
        await $http.post('/v1/client/design/group/copyfurnitureitems', payload);
    } finally {
        commit('setDialog', {visible: false});
    }
};

// 查询已保存的过滤项配置
export const querySavedFilters: IActionFn<IModuleState> = async ({commit}, payload) => {
    try {
        commit('setSavedFilters', {data: [], loading: true});
        const res = await $http.post('/v1/design/dpg/filter/list', {groupId: payload});
        commit('setSavedFilters', {data: res, loading: false});
    } catch (e) {
        commit('setSavedFilters', {data: [], loading: false});
    }
};

// 批量删除过滤项配置
export const deleteDpgFilter: IActionFn<IModuleState> = async (_, payload) => {
    try {
        await $http.post('/v1/design/dpg/filter/delete', payload);
        return true;
    } catch (e) {
        return false;
    }
};

// 保存过滤项配置
export const saveDpgFilter: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        await $http.post('/v1/design/dpg/filter/modify', payload);
        store.commit('common/setToast', {visible: true, text: '保存成功'});
        return true;
    } catch (e) {
        store.commit('common/setToast', {visible: true, text: '保存失败'});
        return false; // 相当于 resolve(false)
    }
};

// 校验展示是否支持移动端可进入
export const validateMobileAccessible: IActionFn<IModuleState> = async (_, showCode) => {
    try {
        const res = await $http.get(`/v1/admin/design/show/${showCode}/mobile-accessible/validate`);
        return res;
    } catch (e) {
        return {canEnable: false, unsupportedItems: [], unsupportedMaterials: [], message: '校验失败'};
    }
};

// 更新展示的移动端可进入状态
export const updateMobileAccessible: IActionFn<IModuleState> = async (_, payload) => {
    try {
        await $http.put('/v1/admin/design/show/mobile-accessible', payload);
        store.commit('common/setToast', {visible: true, text: '更新成功'});
        return true;
    } catch (e) {
        const errorMsg = (e as any)?.message || '更新失败';
        store.commit('common/setToast', {visible: true, text: errorMsg});
        return false;
    }
};
